<template>
    <div class="aside">
        <div class="item">
            <div class="flex-x title">
                <img src="/img/bigdata/title-icon.png" style="width:10px;height:15px;">
                <span>基础信息</span>
            </div>
            <div class="info">
                <div class="num" style="color:#FF464B;margin:10px 0;">{{data.auctionNumber}}</div>
                <i>上拍资产总数</i>
                <div class="flex-x" style="margin-top:20px;">
                    <span class="num" style="color:#D5C301;">{{data.premiumNumber}}</span>
                    <span class="num" style="color:#FB8B65;">{{data.dealRate}}%</span>
                </div>
                <div class="label flex-x" style="margin-top:10px;">
                    <span>溢价资产总数</span>
                    <span>成交率</span>
                </div>
            </div>
            <div class="angle angle-1"></div>
            <div class="angle angle-2"></div>
            <div class="angle angle-3"></div>
            <div class="angle angle-4"></div>
        </div>
        <div class="item">
            <div class="flex-x title" style="padding-bottom:15px;">
                <img src="/img/bigdata/title-icon.png" style="">
                <span>资产平均溢价率</span>
            </div>
            <div class="info">
                <dashboard-progress :rate='data.premiumRate'/>
            </div>
            <div class="angle angle-1"></div>
            <div class="angle angle-2"></div>
            <div class="angle angle-3"></div>
            <div class="angle angle-4"></div>
        </div>
        <div style="height:291px;" class="item">
            <div class="flex-x title">
                <img src="/img/bigdata/title-icon.png" style="width:10px;height:15px;">
                <span>成交资产用途分布</span>
            </div>
            <div>
                <!-- <div id="useMap" style="width:260px;height:230px;"></div> -->
                <usage-dis :data='list'></usage-dis>
            </div>
            <div class="angle angle-1"></div>
            <div class="angle angle-2"></div>
            <div class="angle angle-3"></div>
            <div class="angle angle-4"></div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts'
import {premiumStatistics} from '@/api/premium.js'
import dashboardProgress from './dashboardProgress.vue'
import usageDis from './usageDis.vue'
export default {
    name:'asideInfo',
    data(){
        return{
            percent:75,
            data:{},
            list:[],
            companyId:'',
            colorType:{
                '商铺':'#339AE6',
                '住宅':'#FDD158',
                '市场':'#F5736E',
                '厂房':'#9DE8F6',
                '办公':'#BEE485',
                '土地':'#17C5CA',
                '场地':'#FEAB67',
                '农用地':'#77EFB6',
                '商业':'#AB90DF',
                '其他':'#B8E986',
            }

        }
    },
    components:{
        dashboardProgress,
        usageDis,
    },
    methods:{
        getData(){
            premiumStatistics({companyId:this.companyId}).then(res=>{
                let data = res.data;
                this.data = data.content || {};
                this.data.premiumRate = Number(this.data.premiumRate) ||0;
                this.list = this.data.list||[];
                this.list = this.list.map(item=>{
                    item.value = item.rate;
                    item.itemStyle={
                        color:this.colorType[item.name]
                    }
                    return item;
                 })
            })
        },
    },
    created(){
        this.companyId = this.$route.query.companyId;
    },
    mounted(){
        this.getData();
    }
}
</script>
<style lang="scss">
.ant-progress-circle .ant-progress-text{
    color:#B8D7FF;
}
.flex-x{
    display:flex;
    align-items: center;
    justify-content: space-between;
}
.flex-y{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.angle{
    width:12px;
    height:12px;
    border:1px solid #4291F8;
    position: absolute;
}
.angle-1{
    top:-2px;
    left:-2px;
    border-right:none;
    border-bottom:none;
    border-radius:4px 0 0 0;
}
.angle-2{
    top:-2px;
    right:-2px;
    border-left:none;
    border-bottom:none;
    border-radius:0 4px 0 0;
}
.angle-3{
    bottom:-2px;
    left:-2px;
    border-right:none;
    border-top:none;
    border-radius:0 0 0 4px;
}
.angle-4{
    bottom:-2px;
    right:-2px;
    border-left:none;
    border-top:none;
    border-radius:0 0 4px 0;
}
.aside{
    margin-right: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    div.item{
        position: relative;
        width:294px;
        height:264px;
        padding:18px;
        border-radius:4px;
        border:1px solid rgba(29,62,143,1);
        margin-bottom: 46px;
        text-align: center;
        color:#B8D7FF;
        font-size:16px;
        .title{
            justify-content: flex-start;
            span{
                padding-left: 10px;
            }
        }
        .info{
            .num{
                font-size:32px;
                font-weight:600;
            }
        }

    }
}
</style>


